import RequestUtils from "utils/RequestUtils";
import { MessageAudience } from "api/MessageTemplateApi";

export type SendMethod = "sms" | "mail" | "line";

export interface SendOrderMessageReq {
  audience: MessageAudience;
  sendMethod: SendMethod;
  templateId?: number;
  customSubject?: string;
  customBody?: string;
  smsUnitPrice?: number;
}

export interface SendOrderMessageRes {
  ok: boolean;
  sentAt: string;
  smsBalance: number | null;
}

export interface PreviewOrderMessageReq {
  templateId?: number;
  customSubject?: string;
  customBody?: string;
}

export interface PreviewOrderMessageRes {
  subject: string;
  body: string;
}

export default class OrderMessageApi {
  private constructor() {}

  public static async send(
    companyId: number,
    orderId: number,
    data: SendOrderMessageReq
  ): Promise<SendOrderMessageRes> {
    return RequestUtils.postPlain(
      `/orderMessage/send/${companyId}/${orderId}`,
      data
    ) as Promise<SendOrderMessageRes>;
  }

  public static async preview(
    companyId: number,
    orderId: number,
    data: PreviewOrderMessageReq
  ): Promise<PreviewOrderMessageRes> {
    return RequestUtils.postPlain(
      `/orderMessage/preview/${companyId}/${orderId}`,
      data
    ) as Promise<PreviewOrderMessageRes>;
  }
}
